/**
 * Licensee User Model
 */

define(function(require) {
    'use strict';

    const core = require('core');
    const server = require('server');
    const formatter = require('common/formatter');
    const UserModel = require('modules/user/user.model');

    return UserModel.extend({

        _dispatchAuthEvents: function() {
            core.trigger('change:login');
            return UserModel.prototype._dispatchAuthEvents.apply(this, arguments);
        },

        /**
         * Update user info in IMS. Used in model sync
         * @private
         * @param  {Model}  model   user model
         * @param  {Object} options
         * @return {Deferred}
         */
        _update: function(model, options) {
            return server.send({
                ID: 33045,
                description: 'Update player info',
                responses: [33006, 31008],
                changeTimestamp: formatter.getDateForIms(new Date()),
                addressDetails: this.get('addressDetails') || this.get('userDetails').addressDetails,
                dataMap: options.userDetails || this.get('userDetails')
            }).done(options.success).fail(options.error);
        },

        removePassword: function() {
            const markEmailVerified = this.get('userDetails')?.markEmailVerified;

            if (!Number(markEmailVerified)) {
                return;
            }

            return UserModel.prototype.removePassword.apply(this, arguments);
        }
    });
});
